import React from 'react';
import { Button, Flex, Heading, Text } from 'rebass';
import * as Yup from 'yup';
import PleaseWait from '../../components/PleaseWait';
import { Mutation, Query } from 'react-apollo';
import Select from 'react-select';
import { Form, Formik } from 'formik';
import TextInput, { TextInputWithLabel } from '../../components/TextInput';
import gql from 'graphql-tag';
import { withToastManager } from 'react-toast-notifications';
import { GET_ADMIN_REGIONS } from '../AdminRegions';
import { EditModalButtons } from '../adminHealthCoachFormsTemplate/builder/Builder';
import FormField from '../../components/FormField';

const UPSERT_FORM_TARGET = gql`
  mutation updateRegions(
    $label: String
    $value: String
    $level: String
    $canBookNutritionist: Boolean
    $canBookAsync: Boolean
    $canBookPeriMenopause: Boolean
    $canBookPostMenopause: Boolean
    $canBookWeightLoss: Boolean
    $departmentName: String
  ) {
    updateRegions(
      label: $label
      value: $value
      level: $level
      canBookNutritionist: $canBookNutritionist
      canBookAsync: $canBookAsync
      canBookPeriMenopause: $canBookPeriMenopause
      canBookPostMenopause: $canBookPostMenopause
      canBookWeightLoss: $canBookWeightLoss
      departmentName: $departmentName
    ) {
      ok
    }
  }
`;

const schema = Yup.object().shape({
  // target: Yup.string()
  //   .trim()
  //   .min(2, 'Target name must be greater than 2 characters')
  //   .max(50, 'Target name must be lower than 51 characters')
  //   .required('Required'),
});

const SURVEYS = [
  {
    label: 'full',
    value: 'full',
  },
  {
    label: 'kits only',
    value: 'kit',
  },
  {
    label: 'visits only',
    value: 'visit',
  },
  {
    label: 'none',
    value: 'none',
  },
];
const AdminEditRegion = ({ editItem, close, toastManager, refetch }) => {
  return (
    <Flex flexDirection={'column'} mb={4}>
      <Flex mb={3}>
        <Heading>
          {editItem ? 'Edit' : 'Add'} {editItem.value} Department
        </Heading>
      </Flex>

      <Mutation
        mutation={UPSERT_FORM_TARGET}
        refetchQueries={[{ query: GET_ADMIN_REGIONS }]}
        awaitRefetchQueries={true}
        onCompleted={(e) => {
          if (!!e.updateRegions.ok) {
            toastManager.add(`Department ${editItem.label} edited successfully`, {
              appearance: 'success',
              autoDismissTimeout: 10000,
            });
            refetch();
            close();
          } else {
            toastManager.add('An error occured', {
              appearance: 'error',
              autoDismissTimeout: 10000,
            });
          }
        }}
        onError={() => {
          toastManager.add('An error occured', {
            appearance: 'error',
            autoDismissTimeout: 10000,
          });
        }}
      >
        {(mutate, { loading }) => {
          if (!!loading) {
            return <PleaseWait />;
          }

          return (
            <Formik
              initialValues={{
                ...editItem,
              }}
              isInitialValid={() => {
                return true;
              }}
              validationSchema={schema}
              onSubmit={(values, actions) =>
                mutate({
                  variables: {
                    ...values,
                  },
                })
              }
              render={({ touched, errors, isValid, values, submitForm, setFieldValue, setFieldTouched }) => (
                <Form>
                  <Text>State: {values.label}</Text>
                  <Text mb={2}>Code: {values.value}</Text>
                  <FormField mb={3} error={touched.level && errors.level}>
                    <Select
                      classNamePrefix="region-select"
                      options={SURVEYS}
                      name="level"
                      value={SURVEYS.find((x) => x.value === values.level)}
                      placeholder="select level"
                      onChange={(option) => {
                        setFieldValue('level', option.value);
                      }}
                      onBlur={() => setFieldTouched('level', true)}
                      isSearchable={true}
                    />
                  </FormField>
                  <FormField
                    flexDirection="row"
                    mb={3}
                    style={{
                      alignContent: 'center',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                    }}
                    error={touched.canBookNutritionist && errors.canBookNutritionist}
                  >
                    <TextInput type="checkbox" checked={values.canBookNutritionist} id={`canBookNutritionist`} name="canBookNutritionist" />
                    <label htmlFor="canBookNutritionist" style={{ marginLeft: '16px' }}>
                      Can book nutritionist visits
                    </label>
                  </FormField>
                  <FormField
                    flexDirection="row"
                    mb={3}
                    style={{
                      alignContent: 'center',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      opacity: values.level !== 'visit' && values.level !== 'full' ? 0.5 : 1,
                    }}
                    error={touched.canBookPeriMenopause && errors.canBookPeriMenopause}
                  >
                    <TextInput
                      disabled={values.level !== 'visit' && values.level !== 'full'}
                      type="checkbox"
                      checked={values.canBookPeriMenopause}
                      id={`canBookPeriMenopause`}
                      name="canBookPeriMenopause"
                    />
                    <label htmlFor="canBookPeriMenopause" style={{ marginLeft: '16px' }}>
                      Can book peri-menopause visits ({editItem.periMenoCount})
                    </label>
                  </FormField>
                  <FormField
                    flexDirection="row"
                    mb={3}
                    style={{
                      alignContent: 'center',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      opacity: values.level !== 'visit' && values.level !== 'full' ? 0.5 : 1,
                    }}
                    error={touched.canBookPostMenopause && errors.canBookPostMenopause}
                  >
                    <TextInput
                      type="checkbox"
                      disabled={values.level !== 'visit' && values.level !== 'full'}
                      checked={values.canBookPostMenopause}
                      id={`canBookPostMenopause`}
                      name="canBookPostMenopause"
                    />
                    <label htmlFor="canBookPostMenopause" style={{ marginLeft: '16px' }}>
                      Can book post-menopause visits ({editItem.postMenoCount})
                    </label>
                  </FormField>
                  <FormField
                    flexDirection="row"
                    mb={3}
                    style={{
                      alignContent: 'center',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      opacity: values.level !== 'visit' && values.level !== 'full' ? 0.5 : 1,
                    }}
                    error={touched.canBookWeightLoss && errors.canBookWeightLoss}
                  >
                    <TextInput type="checkbox" disabled={values.level !== 'visit' && values.level !== 'full'} checked={values.canBookWeightLoss} id={`canBookWeightLoss`} name="canBookWeightLoss" />
                    <label htmlFor="canBookWeightLoss" style={{ marginLeft: '16px' }}>
                      Can book weightloss visits ({editItem.wlCount})
                    </label>
                  </FormField>
                  <FormField
                    flexDirection="row"
                    mb={3}
                    style={{
                      alignContent: 'center',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                    }}
                    error={touched.canBookAsync && errors.canBookAsync}
                  >
                    <TextInput type="checkbox" checked={values.canBookAsync} id={`canBookAsync`} name="canBookAsync" />
                    <label htmlFor="canBookAsync" style={{ marginLeft: '16px' }}>
                      Can book async visits
                    </label>
                  </FormField>

                  <EditModalButtons close={close} save={submitForm} isValid={isValid} />
                </Form>
              )}
            />
          );
        }}
      </Mutation>
    </Flex>
  );
};

export default withToastManager(AdminEditRegion);
